import themeClasses from "../themeClasses";
const MbSubscriptionModal = ({ currentTheme = "light" }) => {
  const planBGTxColor =
    currentTheme === "light" ? "bg-white text-black" : "bg-black text-white";
  const plans = [
    {
      name: "Basic",
      price: "$9/mo",
      features: ["✔ 5 Projects", "✔ Email Support", "✖ Advanced Reports"],
      buttonText: "Get Started",
    },
    {
      name: "Pro",
      price: "$29/mo",
      features: [
        "✔ 25 Projects",
        "✔ Priority Support",
        "✔ Reports & Analytics",
      ],
      buttonText: "Start Free Trial",
    },
  ];
  return (
    <div className="pricing-container max-w-[900px] mx-auto mt-15 mb-0 text-center w-full">
      <h2
        className={`pricingTitle text-[28px] font-bold mb-2.5 ${themeClasses[currentTheme].pricingTitle}`}
      >
        Our Pricing Plans
      </h2>
      <p className="pricingSubtitle mb-10">
        Choose a plan that fits your needs
      </p>
      <div className="pricing-plans flex justify-center flex-wrap gap-5">
        {plans.map((plan, idx) => (
          <div
            key={idx}
            className={`plan ${themeClasses[currentTheme].plan} border rounded-2xl w-[350px] p-10 shadow-[0_4px_12px_rgba(0,0,0,0.05)] ${planBGTxColor}`}
          >
            <h3 className="text-lg mb-2.5 font-bold">{plan.name}</h3>
            <div
              className={`price text-4xl font-bold mb-5 ${themeClasses[currentTheme].pricingText}`}
            >
              {plan.price}
            </div>
            <ul className="features list-none p-0 mb-5">
              {plan.features.map((feat, i) => (
                <li key={i} className="my-2">
                  {feat}
                </li>
              ))}
            </ul>
            <button
              className={`btn pricingBtn inline-block px-4 py-2.5 mt-5 rounded-md transition-colors ${themeClasses[currentTheme].pricingBtn} `}
            >
              {plan.buttonText}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MbSubscriptionModal;
